//PAQUETERIAS
import React, { useState } from "react";
import { useDialog } from "react-st-modal";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import MODAL_TABLE from "../../../../main_components/modal/modal_Table";
//COMPONENTES
//ESTILOS
import "../../../estilo.css";
import "../../../modal.css";

//IMAGENES
import { catchErrorModul } from "../../../../main_components/catchErr/catchError";
import { send_invoice_post } from "../../../../services/invoices/invoices";

const FORWARDING_BY_MAIL = (props) => {
  const dialog = useDialog();
  const [isLoding, setIsLoding] = useState(false);
  const [email, setEmail] = React.useState("");
  const handleChangeeEmail = (event) => {
    setEmail(event.target.value);
  };
  const send_email = async () => {
    setIsLoding(true);

    try {
      await send_invoice_post(props.id, props.uuid, email);
      alert("Envío exitoso");
      setIsLoding(false);
      window.location = '/generate_invoice'
      dialog.close();
    } catch (err) {
      var dtErr = { email: email, uuid: props.uuid, id: props.id };
      alert(JSON.stringify(err?.response?.data?.errorMessage?.es));
      catchErrorModul(
        "Envíar Facturas",
        JSON.stringify(dtErr),
        JSON.stringify(err?.response)
      );
      setIsLoding(false);
    }

  };


  return (
    <div>

      <MODAL_TABLE modalGeneral={isLoding} modalT={isLoding} message={"Enviando..."}></MODAL_TABLE>

      <div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%", // Esto es opcional según tus necesidades
          }}
        >
          <textarea
            placeholder="Correos electronicos"
            style={{ width: "90%", height: 44 }}
            onChange={handleChangeeEmail}
          ></textarea>


          <Button
            sx={{ m: 2, width: "92%" }}
            variant="contained"
            onClick={send_email}
          >
            Enviar
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default FORWARDING_BY_MAIL;
